import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { TopReviewType } from '@ugc-components/ugc-pdp-review/interface';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-review-top-review-modal',
  shadow: false,
})
export class UgcReviewTopReviewModal {
  render() {
    const {
      reviewStaticLanguage: { IDS_LBL_MOST_HELPFUL_CRIT_REVIEW = '', IDS_LBL_MOST_HELPFUL_POSI_REVIEW = '' },
      reviewSummary,
      reviewSummaryModalType,
      isShowReviewSummaryModal,
    } = state;
    const modalTitle =
      reviewSummaryModalType === TopReviewType.TopCriticalReview
        ? IDS_LBL_MOST_HELPFUL_CRIT_REVIEW
        : IDS_LBL_MOST_HELPFUL_POSI_REVIEW;

    return (
      <ugc-modal-dialog
        isShow={isShowReviewSummaryModal}
        zIndex={modalZIndex['ugc-top-review-modal']}
        width={600}
        modalTitle={modalTitle}
        handleCancel={() => (state.isShowReviewSummaryModal = false)}
      >
        {isShowReviewSummaryModal && (
          <div class="mt-16 mb-36 px-32">
            <ugc-review-item-top-review reviewItem={reviewSummary[reviewSummaryModalType]} />
          </div>
        )}
      </ugc-modal-dialog>
    );
  }
}
